import React from "react";
import { FaEye, FaLeaf } from "react-icons/fa";
import { featureCards } from "../../../MockData";

const Value = () => {
  return (
    <div className="relative overflow-hidden flax-col flax gap-14 py-16 sm:px-8 lg:px-20">
      <div className="absolute bottom-0 left-0 w-full h-[70%] bg-primary-200 -z-10" />

      <div className="section-container flax grid lg:grid-cols-2 items-center relative">
        <div className="title-space bg-white text-primary-200 p-8 shadow-soft-grey z-10">
          <div className="title-space">
            <div className="section-title">Our Value</div>
            <div className="title-description">
              Extra-ordinary Quality,
              <br />
              extra-ordinary packaging.
            </div>
            <div className="text-text_color-100"> 
            At Thermocraft, we specialize in providing high-quality EPS packaging solutions tailored for durability, safety, and sustainability. Our advanced manufacturing and design processes ensure that every product meets the highest standards.
            </div>
          </div>

          <div className="space-y-6">
            {/* Vision */}
            <div className="flex items-start gap-4">
              <div className="p-3 bg-blue-100 text-white rounded-full">
                <FaEye className="text-xl" />
              </div>
              <div>
                <h4 className="font-semibold text-lg text-text_color-200">
                  Our Vision
                </h4>
                <p className="text-sm text-text_color-100">
                  To be the leading packaging company that delivers innovative
                  and sustainable solutions, enhancing the brand value and
                  customer experience.
                </p>
              </div>
            </div>

            {/* Mission */}
            <div className="flex items-start gap-4">
              <div className="p-3 bg-blue-100 text-white rounded-full">
                <FaLeaf className="text-xl" />
              </div>
              <div>
                <h4 className="font-semibold text-lg text-text_color-200">
                  Our Mission
                </h4>
                <p className="text-sm text-text_color-100">
                  Embrace sustainability by offering eco-friendly packaging
                  solutions that minimize environmental impact throughout the
                  supply chain.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative bottom-16">
          <img
            src={`/assets/new_1.webp`}
            alt="Packaging Machine"
            className="shadow-sharp-blue md:block hidden"
          />
        </div>
      </div>

      {/* Bottom Features */}
      <div className="section-container grid sm:grid-cols-2 md:grid-cols-3 gap-10 text-center text-white relative z-10">
        {featureCards.map((item, index) => (
          <div
            key={index}
            className="flex flex-col justify-center items-center gap-4"
          >
            <div className="text-3xl glass-border p-2 max-w-20 text-blue-100">
              {item.icon}
            </div>
            <div className="flex flex-col gap-2">
              <h4 className="font-semibold text-lg">{item.title}</h4>
              <p className="text-sm ">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Value;
